// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"file-delete_wrapper_p53ic","bottom":"file-delete_bottom_1_uWX"};